module.exports = __webpack_public_path__ + "static/media/services-affiliatons.0f7aada5.png";